/**
 * IonDemoBanner — small banner that surfaces when `?ion_demo=<branch>`
 * is in the URL, so anyone watching the demo (boss, customer call) sees
 * unambiguously that the conversation is a scripted replay, not a live
 * backend roundtrip.
 *
 * Hidden in normal use — `getDemoBranch()` returns null without the URL flag.
 *
 * This component was DEAD for a while: it had zero import sites (most likely it
 * lost its mount when ChatPanel.jsx was replaced by IonSurface.jsx), while its
 * CSS kept shipping. Re-mounted rather than deleted, because the sales demo mode
 * is the one place where a whole conversation is scripted and shown to a
 * customer — that is exactly where a visible marker earns its keep. The
 * capability gallery does NOT need it: it labels each replayed question
 * "Example" per message, which is more precise than a banner over the whole
 * panel.
 *
 * Note this is the SALES demo double-gate (`?ion_demo=` + localStorage, see
 * ionDemoMode.js), not the gallery. Two different replay mechanisms on purpose.
 */

import { getDemoBranch } from '../../services/ionDemoMode.js'

const BRANCH_LABEL = {
  power_tool: 'Power Tool',
  ebike: 'eBike',
  oem_automotive: 'Automotive',
  bess: 'BESS',
  drone: 'Drone',
}

export function IonDemoBanner() {
  const branch = getDemoBranch()
  if (!branch) return null

  return (
    <div class="ion-demo-banner" role="status" aria-live="polite">
      <span class="ion-demo-banner__dot" aria-hidden="true" />
      <span class="ion-demo-banner__label">
        {/* "backend not yet wired" was true when this was written and is not
            any more — the real backend has been live for months. Leaving that
            claim on screen in front of a customer would have been worse than
            having no banner at all. */}
        Demo Mode · {BRANCH_LABEL[branch] || branch} flow (scripted replay, not a live answer)
      </span>
    </div>
  )
}
